import styled from 'styled-components'

export const ScrollableWrapper = styled.div`
  height: 100%;
  overflow: scroll;
  display: block;
  width: 100%;
`
